import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleDuplicateProject(
  state: State,
  { zone, project }: Boundaries["duplicateProject"]["success"],
): State {
  return {
    ...state,
    projects: [...state.projects, { ...project, zone }],
  };
}

export { handleDuplicateProject };
